import React from 'react'
import { inject, observer } from 'mobx-react'
import Name from '../common/Name'
import MoveGeometryButton from 'components/common/tooltips/MoveGeometryButton'
import CopyGeometryButton from 'components/common/tooltips/CopyGeometryButton'
import SharedMessage from '../common/SharedMessage'
import FitRegionButton from '../common/FitRegionButton'
import { withTranslation } from 'react-i18next'
import ExportKMZButton from 'components/common/tooltips/ExportKMZButton'
import ProBadge from 'components/common/ProBadge'
import { startProCheckout } from '../../../proCheckout'
import { HugeiconsIcon } from '@hugeicons/react'
import {
  PaintBoardIcon,
  FileSpreadsheetIcon
} from '@hugeicons/core-free-icons'

const SharedBoundary = ({ boundary, group, uiStore, selectionStore, t }) => (
  <div className='owned-geopolygon'>
    <Name
      label={t('BOUNDARY.BOUNDARY')}
      name={boundary.name}
    />
    <SharedMessage group={group} />
    <section className='owned-geopolygon__list'>
      <button
        className={`color-btn ${uiStore.user && uiStore.user.type === 'starter' ? 'item-controls__disabled' : ''}`}
        onClick={(e) => {
          if (uiStore.user && uiStore.user.type === 'starter') {
            startProCheckout({ uiStore, t })
            return
          }
          selectionStore.selectColorEdit(e, true)
        }}
      >
        <HugeiconsIcon icon={PaintBoardIcon} size={18} className='popup-menu__icon' />
        <span>{t('GLOBAL.COLOR')}</span>
        {uiStore.user && uiStore.user.type === 'starter' &&
          <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
      </button>
      <FitRegionButton item={boundary} />
      <CopyGeometryButton
        lgIcon
        group={group}
        onSubmit={() => uiStore.copyBoundary(boundary, group)}
      />
      <MoveGeometryButton
        lgIcon
        group={group}
        onSubmit={() => uiStore.moveBoundary(boundary, group)}
      />
      <button
        key='btn-excel'
        className={uiStore.user && uiStore.user.type === 'starter' ? 'item-controls__disabled' : ''}
        onClick={(e) => {
          e.stopPropagation()
          if (uiStore.user && uiStore.user.type === 'starter') {
            startProCheckout({ uiStore, t })
            return
          }
          boundary.analysis.exportExcel(boundary.name)
        }}
      >
        <HugeiconsIcon icon={FileSpreadsheetIcon} size={18} className='popup-menu__icon' />
        <span>{t('GLOBAL.EXCEL_EXPORT')}</span>
        {uiStore.user && uiStore.user.type === 'starter' &&
          <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
      </button>
      <ExportKMZButton lgIcon />
    </section>
  </div>
)

export default withTranslation()(inject('uiStore', 'selectionStore')(observer(SharedBoundary)))
